import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/assist-competition-details/:signup_record_id/:activity_id",
  name: "assistCompetitionDetails",
  component: function component() {
    return import("../../../views/dev-plug/assist-competition/details");
  },
  meta: {
    title: "",
    foot: true
  }
}];